function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".guided_svg__cls-1{stroke-linecap:round;fill:none;stroke-linejoin:round;stroke:#63c;stroke-width:4px}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "guided_svg__Layer_1-2"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 48,
  r: 46,
  stroke: "#63c",
  strokeWidth: 4,
  strokeLinejoin: "round",
  fill: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47.86,
  cy: 48,
  r: 33.5,
  stroke: "#ccc0fd",
  strokeWidth: 2,
  strokeLinejoin: "round",
  fill: "none",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  className: "guided_svg__cls-1",
  d: "M38.71 43.94l-8.65 21.62 21.86-8.41"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47.86,
  cy: 48,
  r: 10,
  fill: "#00ffcb",
  stroke: "#63c",
  strokeWidth: 4,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  className: "guided_svg__cls-1",
  d: "M57 52.07l8.65-21.62-21.85 8.41"
}));

function SvgGuided(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "guided_svg__Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJMYXllcl8yIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5NiA5NiI+PGRlZnM+PHN0eWxlPi5jbHMtMSwuY2xzLTJ7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7fS5jbHMtMSwuY2xzLTIsLmNscy0ze2ZpbGw6bm9uZTt9LmNscy0xLC5jbHMtMiwuY2xzLTMsLmNscy00e3N0cm9rZS1saW5lam9pbjpyb3VuZDt9LmNscy0xLC5jbHMtMywuY2xzLTR7c3Ryb2tlOiM2M2M7c3Ryb2tlLXdpZHRoOjRweDt9LmNscy0ye3N0cm9rZTojY2NjMGZkO3N0cm9rZS13aWR0aDoycHg7fS5jbHMtNHtmaWxsOiMwMGZmY2I7fTwvc3R5bGU+PC9kZWZzPjxnIGlkPSJMYXllcl8xLTIiPjxnPjxjaXJjbGUgY2xhc3M9ImNscy0zIiBjeD0iNDgiIGN5PSI0OCIgcj0iNDYiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMiIgY3g9IjQ3Ljg2IiBjeT0iNDgiIHI9IjMzLjUiLz48cG9seWxpbmUgY2xhc3M9ImNscy0xIiBwb2ludHM9IjM4LjcxIDQzLjk0IDMwLjA2IDY1LjU2IDUxLjkyIDU3LjE1Ii8+PGNpcmNsZSBjbGFzcz0iY2xzLTQiIGN4PSI0Ny44NiIgY3k9IjQ4IiByPSIxMCIvPjxwb2x5bGluZSBjbGFzcz0iY2xzLTEiIHBvaW50cz0iNTcgNTIuMDcgNjUuNjUgMzAuNDUgNDMuOCAzOC44NiIvPjwvZz48L2c+PC9zdmc+";
export { SvgGuided as ReactComponent };